import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";

export const getCompanyInfo = (query: string) =>
    axiosInstance.request({
        baseURL: gatewayUrl,
        url: `/company-info`,
        method: "get",
        params: {q: query},
    });
